import script from "./apply-info.vue?vue&type=script&setup=true&lang=ts"
export * from "./apply-info.vue?vue&type=script&setup=true&lang=ts"

import "./apply-info.vue?vue&type=style&index=0&id=95dc79f0&lang=scss"

const __exports__ = script;

export default __exports__